import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Button } from './ui/Button';

/**
 * LOT B3 — coquille MINIMALE du portail client : en-tête (marque + identité + déconnexion) et zone de
 * contenu. Pas de navigation interne (le client n'a accès qu'à ses dossiers), pas de tableau de bord.
 * Réutilise le design system existant (Tailwind / composants ui).
 */
export function PortalLayout(): JSX.Element {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await logout();
    } finally {
      setLoggingOut(false);
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-surface-muted">
      <header className="sticky top-0 z-30 flex items-center justify-between gap-3 bg-brand-900 px-4 py-3 sm:px-6">
        <div className="flex items-center gap-3">
          <span
            aria-hidden="true"
            className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 ring-1 ring-inset ring-white/15"
          >
            <svg viewBox="0 0 24 24" fill="none" className="h-[18px] w-[18px] text-white">
              <path
                d="M4 20V9.2a1 1 0 0 1 .4-.8l7-5.2a1 1 0 0 1 1.2 0l7 5.2a1 1 0 0 1 .4.8V20"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.5 20v-5.5h5V20"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="text-lg font-bold tracking-tight text-white">DERLIZ</span>
          <span className="hidden text-sm text-brand-200 sm:inline">Espace client</span>
        </div>
        <div className="flex items-center gap-3">
          {user ? (
            <span className="hidden text-sm text-brand-100 sm:inline">{user.email}</span>
          ) : null}
          <Button variant="outline" size="sm" onClick={handleLogout} loading={loggingOut}>
            Se déconnecter
          </Button>
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl flex-1 p-4 sm:p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  );
}
